import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import { useOnBeforeSmartviewMount } from '@morningtrain/react-smartviews'

export default function TriggerPipelineOnBeforeSmartviewMount () {
  const pipeline = usePipeline()

  useOnBeforeSmartviewMount(() => {
    return pipeline.trigger({ })
  })

  return null
}
